import { nodeArray } from 'meteora';
import inView from 'in-view';
import { tns } from "tiny-slider/src/tiny-slider";
document.addEventListener('DOMContentLoaded', function () {
  var productSliders = nodeArray(document.querySelectorAll('.js-slider--products'));
  productSliders.forEach(function (slider) {
    var controller = tns({
      container: slider,
      nav: false,
      center: true,
      responsive: {
        768: {
          gutter: 20,
          items: 3
        }
      }
    });
  });
});